import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import EventsTours from "../Tours";
import TajikistanMapTours from "./TajikistanMapTours";

const DiscoverTajikistan = () => {
  const { t } = useTranslation();
  const customTextColor = { color: "rgb(28, 82, 82)" };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="py-5 bg-white" data-aos="fade-right">
      <div className="container p-4">
        <h2 className="fw-bold mb-4 text-center" style={customTextColor}>
          {t("discover.title")}
        </h2>
        <div className="row mb-4">
          <div className="col-12 col-md-6">
            <p className="text-muted">
              <strong style={customTextColor}>{t("discover.subtitle")}</strong>
              <br />
              {t("discover.description")}
            </p>
          </div>
          <div className="col-12 col-md-6">
            <p className="fw-semibold" style={customTextColor}>
              {t("discover.programTitle")}
            </p>
            <ul className="text-muted ps-3">
              <li>{t("discover.programItems.visitCities")}</li>
              <li>{t("discover.programItems.meetings")}</li>
              <li>{t("discover.programItems.presentations")}</li>
            </ul>
            <p className="text-muted">
              Открой Таджикистан — открой новые горизонты для инвестиций.
            </p>
          </div>
        </div>
        <div className="mb-5">
          <TajikistanMapTours />
        </div>
      </div>
      <EventsTours />
    </div>
  );
};

export default DiscoverTajikistan;
